import numeral from 'numeral'
import { isNumber, isString } from 'util'

export const representsNumber = (n: any) => isNumber(n) || (isString(n) && !isNaN(Number(n)))

export function formatAmount(amount: number, unit: string = ''): string {
  const amountLabel = numeral(amount).format('0.[0]a').toUpperCase()
  return `${amountLabel} ${unit}`.trim()
}
